/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import CourseraPlusRecommendationsModule from 'bundles/unified-description-page-common/components/recommendations/CourseraPlusRecommendationsModule';
import Section from 'bundles/unified-description-page-common/components/shared/Section';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import ArticlesRecommendationsModuleRenderer from 'bundles/unified-description-page-common/module-renderers/ArticlesRecommendationsModuleRenderer';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

// eslint-disable-next-line @coursera-web/custom-rules/i18n-import-rule
import _t from 'i18n!nls/xdp';

type Props = {
  pageData: ConsumerSpecializationPageFieldsFragment;
};

const CourseraPlusRecommendationsAndArticlesModuleRenderer = ({ pageData }: Props) => {
  const { navigationIdMap } = usePageInfo();
  return (
    <div
      css={css`
        margin-top: calc(-1 * var(--cds-spacing-600));
      `}
    >
      <Section anchorId={navigationIdMap?.RECOMMENDATIONS} spacing={0}>
        <CourseraPlusRecommendationsModule />
      </Section>
      <ArticlesRecommendationsModuleRenderer
        pageData={pageData}
        config={{ title: _t('Career resources'), titleTypographyVariant: 'titleSmall' }}
      />
    </div>
  );
};

export default CourseraPlusRecommendationsAndArticlesModuleRenderer;
